import { useContext } from 'react';
import { SettingsContext } from '../contexts/SettingsContext.js';
import 'react/jsx-runtime';
import '../global/constants/index.js';

const useSettings = () => useContext(SettingsContext);

export { useSettings };
